import VueCookies from 'vue-cookies'
import {coreApi} from './core'
import axios from 'axios'

export const authService = {

    // dd: {
    //     "Username": "test",
    //     "Password": null,
    //     "Id": null,
    //     "FullName": null,
    //     "Email": "test@test.uz",
    //     "Role": "Admin",
    //     "JwtToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InRlc3QiLCJnaXZlbl9uYW1lIjoibmFtZSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvdXNlcmRhdGEiOiI1ZmFlNTdiODA4NDYwNzhhNjZmNDk5MzAiLCJlbWFpbCI6InRlc3RAdGVzdC51eiIsInJvbGUiOiJBZG1pbiIsIm5iZiI6MTYwNzU1MDg0OCwiZXhwIjoxNjA3NTc5NjQ4LCJpYXQiOjE2MDc1NTA4NDh9.0gz_T3nr4wdGjFSLSj-kb4To84ycwixIsCuwbu5Y2S8"
    // },

    getToken() {
        return VueCookies.get('token')
    },
    getUser() {
        return {
            name: VueCookies.get('name'),
            role: VueCookies.get('role')
        }
    },
    removeToken() {
        VueCookies.remove('token')
    },
    removeUser() {
        VueCookies.remove('user')
    },
    setHeader(token) {
        coreApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    removeHeader() {
        delete axios.defaults.headers.common['Authorization']
    },
    setToken(token) {
        VueCookies.set('token', token)
    },
    setUser(user) {
        VueCookies.set('name', user.FullName)
        VueCookies.set('role', user.Role.toLowerCase())
    },
    verify(phone) {
        return new Promise((resolve, reject) => {
            coreApi
                .post(`/auth/verify`, {phone})
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

    login(user) {
        return new Promise((resolve, reject) => {
            coreApi
                .post(`/user/login`, user)
                .then(response => {
                    authService.setToken(response.data.JwtToken)
                    authService.setUser(response.data)
                    authService.setHeader(response.data.JwtToken)
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

    login_password({phone, password, remember_me = false}) {
        return new Promise((resolve, reject) => {
            coreApi
                .post(`/auth/login_password`, {phone, password, remember_me})
                .then(response => {
                    this.setToken(response.data.access_token)
                    authService.setHeader(response.data.access_token)
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

    app() {
        return new Promise((resolve, reject) => {
            coreApi
                .get(`/app`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

    async logout() {
        this.removeToken()
        this.removeUser()
        await authService.removeHeader()
        window.location.replace('/auth')
    },

    forceLogout() {
        return new Promise(resolve => {
            this.removeToken()
            this.removeUser()
            authService.removeHeader()
            window.location.replace('/auth')
            resolve()
        })
    },
}
